import outdatedBrowserRework from "outdated-browser-rework";

outdatedBrowserRework();